import { getHours, getMinutes, isSameDay, set } from 'date-fns';
import { JobTask } from '@root/globalTypes';
import { toLocalWallClock, toTenantDate } from '@utils/timeZone';

export const getRelatedStarts = (tasks: JobTask[] = []) =>
  tasks
    .map((task) => task.schedule?.startsAt)
    .filter((startsAt): startsAt is string => Boolean(startsAt))
    .map((startsAt) => toLocalWallClock(toTenantDate(startsAt)));

export const getRelatedStartMinutes = (day: Date, starts: Date[]) => {
  const minutes = starts
    .filter((start) => isSameDay(start, day))
    .map((start) => getHours(start) * 60 + getMinutes(start));
  return minutes.length ? Math.min(...minutes) : undefined;
};

export const toMinutes = (value?: Date) =>
  value ? getHours(value) * 60 + getMinutes(value) : undefined;

export const withTime = (day: Date, minutes: number) =>
  set(day, { hours: Math.floor(minutes / 60), minutes: minutes % 60, seconds: 0, milliseconds: 0 });
